module.exports = __webpack_public_path__ + "img/pinkys.7ec1d202.png";